export default __webpack_public_path__ + "static/media/wave.17df03b1.svg";